<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่ม Device ในกลุ่ม</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pt-2 px-4" style="height: 100%; overflow: auto">
        <v-row>
          <v-col class="py-0" cols="12" lg="6">
            <label class="caption"> ค้นหา </label>
            <v-text-field
              v-model="search"
              class="fix-google-chrome"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              @input="handleSearchTaHardware"
              hide-details
            >
            </v-text-field
          ></v-col>
          <v-col class="py-0" cols="12" lg="6">
            <label class="caption"> รุ่นของ Device </label>
            <v-autocomplete
              v-model="taHardwareModelFilter"
              class="fix-google-chrome"
              :items="taHardwareModels"
              item-text="title"
              item-value="hardware_model_code"
              hide-details
              outlined
              dense
              clearable
              @change="handleFilterTaHardwareModel"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
        <div class="d-lg-flex justify-space-between align-baseline mb-4">
          <div class="ml-4 d-inline-flex align-center">
            <input
              :disabled="pagination.isLoading || !taHardwaresGroupMember.length"
              :indeterminate.prop="indeterminateSelectAll"
              id="selectAll"
              style="width: 18px; height: 18px"
              type="checkbox"
              :checked="checkedSelectAll"
              @input="handleSelectAll"
            />
            <label for="selectAll" class="ml-4" style="font-size: 14px">
              เลือกทั้งหมด
            </label>
          </div>
          <div style="width: 200px">
            <v-select
              style="font-size: 14px"
              v-model="sort"
              :disabled="pagination.isLoading"
              prepend-inner-icon="mdi-sort-ascending"
              :items="sorts"
              hide-details
              @change="handleChangeSort"
            ></v-select>
          </div>
        </div>
        <DynamicScroller
          :items="taHardwaresGroupMember"
          :min-item-size="pagination.limit"
          key-field="hardware_uuid"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
            >
              <v-card
                color="#f5f5f5"
                outlined
                class="d-flex align-center mb-2"
                v-observe-visibility="
                  item.hardware_uuid === lastHardware.hardware_uuid &&
                  !isLastPage
                    ? infiniteScrollHandler
                    : false
                "
              >
                <span class="pa-4">
                  <input
                    :id="item.hardware_uuid"
                    :value="item.hardware_uuid"
                    v-model="taHardwaresSelected"
                    style="width: 18px; height: 18px"
                    type="checkbox"
                  />
                </span>
                <v-list-item two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.hardware_code }} - {{ item.title_th }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      รุ่น : {{ item.hardware_model.title }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <div v-if="pagination.isLoading">
          <v-card
            color="#f5f5f5"
            v-for="num in 2"
            :key="num"
            outlined
            class="mb-2 px-4 py-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3 text-capitalize"
            :disabled="!isTaHardwareGroupAddDataChange"
            depressed
            @click="onSubmit"
          >
            เพิ่ม Device
          </v-btn>
          <v-btn depressed @click="handleCancel"> ยกเลิก </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    taHardwareGroup: {
      type: Object,
    },
    taHardwareGroupInit: {
      type: Object,
    },
  },
  watch: {
    formShow(value) {
      if (value) {
        this.taHardwaresGroupMember = []
        this.pagination.currentPage = 1
        this.totalTaHardwaresGroupMember = 0
        this.getTaHardwaresGroupMember()
      }
    },
  },
  data() {
    return {
      taHardwaresSelected: [],
      taHardwareModelFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: true,
      },
      taHardwaresGroupMember: [],
      totalTaHardwaresGroupMember: 0,
      sort: 'hardware_code,asc',
      sorts: [
        { id: 1, text: 'เรียงตามรหัส', value: 'hardware_code,asc' },
        { id: 2, text: 'เรียงตามชื่อ (a - z)', value: 'title_th,asc' },
      ],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    checkedSelectAll() {
      return (
        this.taHardwaresSelected.length &&
        this.taHardwaresSelected.length === this.totalTaHardwaresGroupMember
      )
    },
    indeterminateSelectAll() {
      return (
        this.taHardwaresSelected.length &&
        this.taHardwaresSelected.length !== this.totalTaHardwaresGroupMember
      )
    },
    lastHardware() {
      const [lastItem] = this.taHardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalTaHardwaresGroupMember / this.pagination.limit)
      )
    },
    taHardwareModels() {
      return this.$store.state.hardware.hardwareModels.filter(
        (h) => !['q2', 'q3', 'acu81'].includes(h.hardware_model_code)
      )
    },
    isTaHardwareGroupAddDataChange() {
      if (this.taHardwaresSelected.length) {
        this.$emit('isTaHardwareGroupAddDataChange', true)
        return true
      }
      this.$emit('isTaHardwareGroupAddDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchTaHardwaresGroupMember:
        'taHardwaresGroup/fetchTaHardwaresGroupMember',
      addTaHardwareGroupMember: 'taHardwaresGroup/addTaHardwareGroupMember',
      fetchTaHardwareGroupById: 'taHardwaresGroup/fetchTaHardwareGroupById',
    }),
    async handleSelectAll(event) {
      try {
        const isChecked = event.target.checked
        if (isChecked) {
          if (
            this.totalTaHardwaresGroupMember ===
            this.taHardwaresGroupMember.length
          ) {
            this.taHardwaresSelected = this.taHardwaresGroupMember.map(
              (e) => e.hardware_uuid
            )
          } else {
            this.$store.state.loading = true

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              hardware_group_uuid: this.taHardwareGroup.hardware_group_uuid,
              query: {
                hardware_model_code: this.taHardwareModelFilter || undefined,
                search: this.search || undefined,
                sort: this.sort,
                is_outside_group: true,
              },
            }

            const { data: taHardwaresGroupMember } =
              await this.fetchTaHardwaresGroupMember(payload)
            this.taHardwaresSelected = taHardwaresGroupMember.map(
              (e) => e.hardware_uuid
            )
            this.$store.state.loading = false
          }
        } else {
          this.taHardwaresSelected = []
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterTaHardwareModel() {
      this.taHardwaresSelected = []
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    },
    handleSearchTaHardware: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.taHardwaresSelected = []
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    }, 1000),
    handleChangeSort() {
      this.taHardwaresSelected = []
      this.taHardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getTaHardwaresGroupMember()
    },
    async getTaHardwaresGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.taHardwareGroup.hardware_group_uuid,
          query: {
            hardware_model_code: this.taHardwareModelFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_outside_group: true,
          },
        }
        const {
          total: totalTaHardwaresGroupMember,
          data: taHardwaresGroupMember,
        } = await this.fetchTaHardwaresGroupMember(payload)
        this.totalTaHardwaresGroupMember = totalTaHardwaresGroupMember
        this.setTaHardwaresGroupMember(taHardwaresGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextTaHardwaresGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getTaHardwaresGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setTaHardwaresGroupMember(taHardwaresGroupMember) {
      this.taHardwaresGroupMember = [
        ...this.taHardwaresGroupMember,
        ...taHardwaresGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextTaHardwaresGroupMember()
      }
    },
    async onSubmit() {
      try {
        this.search = ''
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company
        const hardware_group_uuid = this.taHardwareGroup.hardware_group_uuid

        const payload = {
          company_uuid,
          hardware_group_uuid,
          body: {
            hardware_uuids: this.taHardwaresSelected,
          },
        }

        await this.addTaHardwareGroupMember(payload)
        const taHardwareGroup = await this.fetchTaHardwareGroupById({
          company_uuid,
          hardware_group_uuid,
        })
        this.$store.commit(
          'taHardwaresGroup/EDIT_TA_HARDWARE_GROUP',
          taHardwareGroup
        )
        this.taHardwaresSelected = []
        this.$emit('addTaHardwareGroupMemberSuccess', taHardwareGroup)
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'เพิ่มข้อมูลสำเร็จ',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleCancel() {
      this.taHardwaresSelected = []
      this.$emit('onClickBlack')
    },
    handleBack() {
      if (this.isTaHardwareGroupAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBlack')
    },
  },
}
</script>
